import Types from '../../reducers/app/types';

export default constants => ({
  type: Types.SET_CONSTANTS,
  payload: constants,
});
